<template>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2 class="mb-4">{{__('lang.shoppingcart.itemdelete')}}</h2>
      <form class="needs-validation" method="post" novalidate="novalidate">
        <p class="alert alert-danger">{{__('lang.shoppingcart.confirmdelete')}}</p>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-6 order-2 order-md-1">
            <button id="closeModal" class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.cancel')}}
            </button>
          </div>
          <div class="form-group col-12 col-md-6 order-1 order-md-2">
            <button class="btn btn-primary btn-block border-0" type="submit" @click.prevent="removeCartItem">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.confirm')}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!--
  <div class="container-fluid">
   <div class="row">
    <div class="col-12">
      <h2 class="mb-4">{{__('lang.shoppingcart.position.create')}}</h2>
      <form class="needs-validation" method="post" novalidate="novalidate">
        <div class="form-row">
          <div class="form-group col-12">
            <label class="col-form-label col-form-label-sm required" for="formfield_1">{{__('lang.shoppingcart.position.head')}}</label>
            <textarea class="form-control" name="formfield_1" required="required"></textarea>
            <div class="invalid-feedback">{{__('lang.shoppingcart.position.message')}}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
            <div class="custom-control custom-radio">
              <input class="custom-control-input" id="formfield_2_1" type="radio" name="formfield_2" checked="checked"/>
              <label class="custom-control-label" for="formfield_2_1">{{__('lang.shoppingcart.position.rb1')}}</label>
            </div>
            <div class="custom-control custom-radio">
              <input class="custom-control-input" id="formfield_2_2" type="radio" name="formfield_2"/>
              <label class="custom-control-label" for="formfield_2_2">{{__('lang.shoppingcart.position.rb2')}}</label>
            </div>
            <div class="custom-control custom-radio">
              <input class="custom-control-input" id="formfield_2_3" type="radio" name="formfield_2"/>
              <label class="custom-control-label" for="formfield_2_3">{{__('lang.shoppingcart.position.rb3')}}</label>
            </div>
          </div>
        </div>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-6 order-2 order-md-1">
            <button class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.cancel')}}
            </button>
          </div>
          <div class="form-group col-12 col-md-6 order-1 order-md-2">
            <button class="btn btn-primary btn-block border-0"  @click.prevent="storeCategories">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.submit')}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div> -->




</template>

<script>
   
    export default {
        props:['shoppingcart_item'],
        computed: {
          
        },
        data() {
          return {
           
          }
		    },
        methods: {  
          removeCartItem:function(){
            this.$store.commit('shoppingcart/removeCartItem', this.shoppingcart_item)
    				this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.alert.shoppingcart.aticle_delete_success')})
            document.getElementById('closeModal').click();
          },

        },
        mounted () {
        },
        created() {
         
        },
       /*
        watch: {
          selectedcategories:{
            handler: function(){
              this.storeCategories();
            },
            deep:true //You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
          }
        }
        */
        
       
        


       
    }
  

</script>